import pakTani from 'assets/icons/Pak Tani.png'
import AmountInput from 'components/AmountInput'
import LandplotInputSelection from 'components/LandplotSelection.js'
import PMBInputNumber from 'components/PMBInputNumber'
import PMBProjectSelections from 'components/PMBProjectSelections'
import PMBSelect from 'components/PMBSelect'
import { itemUnitList } from 'constants'
import InputAddressBook from 'features/private-views/address-book/InputAddressBook'
import ModalAddContact from 'features/private-views/address-book/ModalAddContact'
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from 'features/private-views/address-book/addressBookSlice'
import { purchaseCommodityCheckUser } from 'features/private-views/purchase-commodity/purchaseCommodityAction'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import moment from 'moment-timezone'
import { useEffect, useRef, useState } from 'react'
import { AlertCircle, Calendar, MapPin } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Input,
} from 'reactstrap'
import { formatInputNumber } from 'utility/Utils'
import { getWarehouseForAdd } from '../../API/manageStockAction'
import UploadImageCard from '../Card/UploadImageCard'
import InventoryCodeInput from '../Input/InventoryCodeInput'
import ProfilePic from 'components/PMBProfilePic'
import PriceReference from 'features/private-views/sell-commodity/InfoItem/PriceReference'

export default function AddStockModal({
  isOpen,
  onClose,
  onChangeDataStock,
  dataStock,
  onShowItem,
  onCreateStock,
  loading,
  locationBlocked,
  onChangeAmount,
  onChangeUnitValue,
  defaultWarehouse,
  items,
  onSelectItem,
  selectedUnit,
  onSelectItemUnit,
  isDetail,
}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const addressBookRef = useRef(null)
  const [isButtonDisabled, setButtonDisabled] = useState(false)
  const [isFetchingAddressBook, setIsFetchingAddressBook] = useState(false)
  const [defaultWarehouseAddInventory, setDefaultWarehouseAddInventory] =
    useState(null)
  const [isPanen, setIsPanen] = useState(false)
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format('YYYY-MM-DD'),
  )
  const [selectedContact, setSelectedContact] = useState(null)
  const [dataSeller, setDataSeller] = useState(null)
  const [errMsgPhone, setErrMsgPhone] = useState('')
  const [selectedProject, setSelectedProject] = useState(null)

  const { isModalOpenAddAddressBook } = useSelector((e) => e.addressBook)
  const { warehousesAdd, landplots } = useSelector((s) => s.manageStock)
  const { ownerData } = useSelector((e) => e.dashboard)

  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  const handleSelectedContact = (contact) => {
    setSelectedContact(contact)
  }

  useEffect(() => {
    if (dataStock?.amount && dataStock?.itemId && dataStock.unit) {
      setButtonDisabled(false)
    } else {
      setButtonDisabled(true)
    }
  }, [dataStock])

  useEffect(() => {
    if (!warehousesAdd) {
      dispatch(getWarehouseForAdd({ isForFilter: true, isAdd: true }))
    }
  }, [warehousesAdd])

  // Normalize QR-prefilled warehouse (id/value/name/object) to actual warehouse id.
  useEffect(() => {
    if (!warehousesAdd?.newData?.length) return

    const rawWarehouse = dataStock?.warehouseId
    if (
      rawWarehouse === null ||
      rawWarehouse === undefined ||
      rawWarehouse === ''
    ) {
      return
    }

    const normalizedRaw = String(rawWarehouse).trim().toLowerCase()
    const matchedWarehouse = warehousesAdd.newData.find((w) => {
      const id = String(w?.id ?? '')
        .trim()
        .toLowerCase()
      const value = String(w?.value ?? '')
        .trim()
        .toLowerCase()
      const name = String(w?.name ?? '')
        .trim()
        .toLowerCase()
      const label = String(w?.label ?? '')
        .trim()
        .toLowerCase()

      return (
        normalizedRaw === id ||
        normalizedRaw === value ||
        normalizedRaw === name ||
        normalizedRaw === label
      )
    })

    if (
      matchedWarehouse &&
      String(matchedWarehouse?.id) !== String(dataStock?.warehouseId)
    ) {
      onChangeDataStock('warehouseId', matchedWarehouse.id)
    }
  }, [warehousesAdd?.newData, dataStock?.warehouseId, onChangeDataStock])

  // useEffect(() => {
  //   if (!landplots) {
  //     dispatch(getLandplot())
  //   }
  // }, [landplots])

  useEffect(() => {
    const relationPhoneOrEmail =
      selectedContact?.relationPhoneNumber ?? selectedContact?.relationEmail

    if (relationPhoneOrEmail) {
      if (ownerData?.userId !== selectedContact?.relationUserId) {
        handleSubmit(relationPhoneOrEmail)
        onChangeDataStock('sellerPhone', relationPhoneOrEmail)
      }
      setErrMsgPhone('')
    } else {
      onChangeDataStock('sellerPhone', null)
      setSelectedContact(null)
      setDataSeller(null)
      setErrMsgPhone('')
    }
  }, [selectedContact])

  useEffect(() => {
    if (!isPanen) {
      onChangeDataStock('recordTime', null)
      onChangeDataStock('landplottingId', null)
      onChangeDataStock('sellerPhone', null)
      setDataSeller(null)
      setSelectedContact(null)
    }
  }, [isPanen])

  // Reset selectedProject when modal is closed
  useEffect(() => {
    if (!isOpen) {
      setSelectedProject(null)
    }
  }, [isOpen])

  useEffect(() => {
    const isReset =
      (dataStock?.itemId === null ||
        dataStock?.itemId === undefined ||
        dataStock?.itemId === '') &&
      (dataStock?.amount === null ||
        dataStock?.amount === undefined ||
        dataStock?.amount === 0) &&
      (!dataStock?.nameItem || dataStock?.nameItem === '')

    if (isReset && !isPanen) {
      setSelectedProject(null)
      setSelectedContact(null)
      setDataSeller(null)
      setIsPanen(false)
      setSelectedDate(moment(new Date()).format('YYYY-MM-DD'))
    }
  }, [dataStock, isPanen])

  // SET DEFAULT VALUE WAREHOUSE
  useEffect(() => {
    if (!dataStock?.warehouseId && defaultWarehouse?.id) {
      setDefaultWarehouseAddInventory(defaultWarehouse?.id)
      onChangeDataStock('warehouseId', defaultWarehouse?.id)
    }
  }, [dataStock?.warehouseId, defaultWarehouse?.id, onChangeDataStock])

  const handleInventoryCodeChange = (code) => {
    onChangeDataStock('ownerCode', code)
  }

  const handleSubmit = async (phoneOrEmail) => {
    if (phoneOrEmail) {
      setErrMsgPhone('')
      const { payload } = await dispatch(
        purchaseCommodityCheckUser({
          search: encodeURIComponent(phoneOrEmail),
          type: 'HARVEST',
        }),
      )

      if (typeof payload === 'object') {
        setDataSeller(payload)
      } else {
        setErrMsgPhone(payload)
      }
    }
  }

  return (
    <>
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        isPhoneVerified
        isHarvester
        isOutsideAddressBook
      />
      <div className="regular-padding-horizontal regular-padding-top d-flex justify-content-between align-items-center">
        <CardTitle className="fw-semibold text-md">Tambah Inventori</CardTitle>
      </div>
      {locationBlocked ? (
        <div className="regular-padding-horizontal small-padding-vertical">
          <Card
            className="small-padding border-0 shadow-sm"
            style={{ backgroundColor: '#F3FEFF', borderColor: '#8ABBCC' }}
          >
            <div className="d-flex">
              <MapPin className="small-margin-right" color="#006386" />
              <CardText style={{ fontSize: 14 }}>
                Untuk mencatat lokasi dari stok yang ditambahkan, harap aktifkan
                layanan lokasi di perangkat Anda.
              </CardText>
            </div>
          </Card>
        </div>
      ) : null}

      <div className="regular-padding">
        {(
          isPanen
            ? warehousesAdd?.newData?.length > 0 &&
              ownerData?.userId ===
                (selectedContact?.relationUserId ?? dataSeller?.userId)
            : warehousesAdd?.newData?.length > 0
        ) ? (
          <div>
            <CardText className="no-padding">
              Kode inventori (opsional)
            </CardText>
            <InventoryCodeInput
              value={dataStock?.ownerCode || ''}
              onChange={handleInventoryCodeChange}
              // isAutoFocus
            />
          </div>
        ) : (
          <></>
        )}
        <div className="mt-4">
          <CardText className="no-padding">
            Barang
            <span style={{ color: '#b42218' }}>*</span>
          </CardText>
          <div
            style={{ width: '100%' }}
            data-testid="inventory-commodity-select"
          >
            <PMBSelect
              placeholder="Pilih barang"
              className="mt-2"
              options={items?.map((el) => ({
                value: el.nameItem?.toLowerCase(),
                label: el.nameItem,
                ...el,
              }))}
              value={(() => {
                const normalizedItemId =
                  dataStock?.itemId !== null && dataStock?.itemId !== undefined
                    ? String(dataStock.itemId)
                    : ''
                const normalizedName = String(dataStock?.nameItem || '')
                  .trim()
                  .toLowerCase()

                const found = items?.find((el) => {
                  const byId = normalizedItemId
                    ? String(el?.id) === normalizedItemId
                    : false
                  const byName = normalizedName
                    ? String(el?.nameItem || '')
                        .trim()
                        .toLowerCase() === normalizedName
                    : false
                  return byId || byName
                })
                if (!found) return null
                return {
                  value: found.nameItem?.toLowerCase(),
                  label: found.nameItem,
                  ...found,
                }
              })()}
              onChange={(selectedItem) => onSelectItem(selectedItem)}
            />
          </div>
        </div>
        {dataStock?.nameItem ? (
          <div className="mt-4">
            <UploadImageCard
              onChangeDataStock={onChangeDataStock}
              uploadedImage={dataStock?.linkFoto}
            />
          </div>
        ) : null}
        <div className="d-flex justify-content-between">
          <div className="mt-4" style={{ width: '49%' }}>
            <CardText className="no-padding">
              Jumlah<span style={{ color: '#b42218' }}>*</span>
            </CardText>
            <div className="mt-2 d-flex justify-content-between align-items-center">
              <PMBInputNumber
                onFocus={(e) => e.target.select()}
                value={formatInputNumber(dataStock.amount)}
                name="quantity"
                placeholder="Masukkan jumlah"
                isLastPrefix
                onChange={(e) =>
                  onChangeAmount(
                    'amount',
                    e.target.value,
                    onChangeDataStock,
                    dataStock,
                  )
                }
                testId="inventory-quantity-input"
              />
            </div>
          </div>
          <div
            className="mt-4"
            style={{ width: '49%' }}
            data-testid="inventory-unit-select"
          >
            <CardText className="no-padding">
              Satuan<span style={{ color: '#b42218' }}>*</span>
            </CardText>
            <PMBSelect
              options={itemUnitList?.map((el) => ({
                value: el.title?.toLowerCase(),
                label: el.title,
                ...el,
              }))}
              className="mt-2"
              isMulti={false}
              value={
                selectedUnit && selectedUnit?.value
                  ? selectedUnit
                  : dataStock?.unit
                    ? {
                        value: dataStock?.unit?.toString(),
                        label: dataStock?.unit,
                      }
                    : null
              }
              onChange={(selectedUnit) => onSelectItemUnit(selectedUnit)}
              placeholder="Pilih Satuan"
            />
            {/* <div className="bordered mt-2 d-flex justify-content-between align-items-center">
              <Input
                style={{ borderColor: 'white', caretColor: 'transparent' }}
                className="border-input button"
                placeholder="Pilih Satuan"
                value={dataStock?.unit}
                onClick={() => {
                  onShowItem('itemUnit', true)
                }}
              />
              <ChevronDown color="#667085" style={{ paddingRight: 10 }} />
            </div> */}
          </div>
        </div>

        <div className="mt-4 w-100">
          <CardText className="no-padding">Harga satuan (opsional)</CardText>
          <div className="mt-2 d-flex justify-content-between align-items-center">
            <AmountInput
              name="unitValue"
              value={dataStock?.unitValue ?? ''}
              cb={(e) =>
                onChangeUnitValue('unitValue', e, onChangeDataStock, dataStock)
              }
              placeholder="Masukkan harga satuan"
              testId="inventory-unit-price-input"
            />
          </div>
          <PriceReference
            itemId={dataStock?.itemId}
            currentPrice={dataStock?.unitValue}
            currentUnit={selectedUnit?.label || dataStock?.unit}
            onUsePrice={(price, unit) => {
              onChangeUnitValue(
                'unitValue',
                String(price),
                onChangeDataStock,
                dataStock,
              )
              if (unit) {
                onSelectItemUnit({
                  label: unit,
                  value: unit.toLowerCase(),
                  title: unit,
                })
              }
            }}
          />
        </div>

        <div className="mt-4 w-100">
          <CardText className="no-padding">Bundle (opsional)</CardText>
          <div className="mt-2 d-flex justify-content-between align-items-center">
            <PMBInputNumber
              onFocus={(e) => e.target.select()}
              value={dataStock?.bundle ?? ''}
              name="bundle"
              placeholder="Masukkan jumlah bundle"
              isLastPrefix
              onChange={(e) => {
                const val = e.target.value?.replace(/[^\d]/g, '')
                onChangeDataStock('bundle', val ? Number(val) : '')
              }}
              testId="inventory-bundle-input"
            />
          </div>
        </div>

        {(isPanen
          ? warehousesAdd?.newData?.length > 0 &&
            ownerData?.userId ===
              (selectedContact?.relationUserId ?? dataSeller?.userId)
          : warehousesAdd?.newData?.length > 0) && !isDetail ? (
          <div className="mt-4">
            <div className="d-flex align-items-center">
              <div style={{ width: '100%' }}>
                <CardText className="m-0 mb-1">
                  Gudang<span style={{ color: '#b42218' }}>*</span>
                </CardText>
                <PMBSelect
                  options={warehousesAdd?.newData}
                  onChange={(text) =>
                    onChangeDataStock('warehouseId', text?.id)
                  }
                  placeholder="Pilih gudang"
                  value={warehousesAdd?.newData?.find((e) => {
                    const normalizedCurrent = String(
                      dataStock?.warehouseId ?? '',
                    )
                      .trim()
                      .toLowerCase()
                    return (
                      String(e?.id ?? '')
                        .trim()
                        .toLowerCase() === normalizedCurrent ||
                      String(e?.value ?? '')
                        .trim()
                        .toLowerCase() === normalizedCurrent ||
                      String(e?.name ?? '')
                        .trim()
                        .toLowerCase() === normalizedCurrent ||
                      String(e?.label ?? '')
                        .trim()
                        .toLowerCase() === normalizedCurrent
                    )
                  })}
                  testId="inventory-warehouse-select"
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="mt-4">
          <CardText className="no-padding">Project (opsional)</CardText>
          <div style={{ width: '100%' }}>
            <PMBProjectSelections
              placeholder="Pilih project"
              className="mt-2"
              value={selectedProject}
              onChange={(project) => setSelectedProject(project)}
              testId="inventory-project-select"
            />
          </div>
        </div>

        {(
          isPanen
            ? warehousesAdd?.newData?.length > 0 &&
              ownerData?.userId ===
                (selectedContact?.relationUserId ?? dataSeller?.userId)
            : warehousesAdd?.newData?.length > 0
        ) ? (
          <div className="mt-4">
            <CardText className="no-padding">
              Catatan tambahan (opsional)
            </CardText>
            <div className="d-flex align-items-center">
              <div className="bordered mt-2" style={{ width: '100%' }}>
                <Input
                  style={{ borderColor: 'white', height: 200 }}
                  value={dataStock?.description}
                  className="border-input"
                  type="textarea"
                  placeholder="Masukkan catatan jika ada..."
                  onChange={(text) =>
                    onChangeDataStock('description', text.target.value)
                  }
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="mt-4 fw-bold">
          <Input
            type="checkbox"
            onChange={() => {
              if (isPanen) {
                setIsPanen(false)
              } else {
                setIsPanen(true)
              }
            }}
            checked={isPanen}
          />{' '}
          Catat hasil panen
        </div>

        {isPanen ? (
          <>
            {' '}
            <div className="mt-4">
              <CardText className="m-0 mb-1">
                Tanggal Panen<span style={{ color: '#b42218' }}>*</span>
              </CardText>
              <div className="d-flex align-items-center justify-content-center border rounded">
                <Calendar size={17} className="ms-3" />
                <Flatpickr
                  options={{
                    locale: Indonesian,
                    dateFormat: 'd-M-Y',
                    defaultDate: new Date(),
                    maxDate: new Date(),
                    onClose: (selectedDate, dateStr, instance) => {
                      setSelectedDate(
                        moment(selectedDate[0]).local().format('YYYY-MM-DD'),
                      )
                      onChangeDataStock(
                        'recordTime',
                        moment(selectedDate[0]).valueOf(),
                      )
                    },
                  }}
                  className="form-control flat-picker bg-transparent border-0 shadow-none"
                />
              </div>
            </div>
            <div className="mt-4">
              <InputAddressBook
                title="Pemanen"
                isRequired
                isHarvester
                // isLandOwner
                onSelectContact={handleSelectedContact}
                fieldName="relationName"
                editValue={
                  selectedContact?.relationPhoneNumber
                    ? `${selectedContact?.relationName} (${selectedContact?.relationPhoneNumber})`
                    : selectedContact?.relationEmail
                      ? `${selectedContact?.relationName} (${selectedContact?.relationEmail})`
                      : selectedContact?.relationName
                }
                onClickAdd={(localSearch) =>
                  dispatch(setSearchAddressBook(localSearch))
                }
                isOutsideAddressBook
                onFetchingChange={setIsFetchingAddressBook}
                innerRef={addressBookRef}
                isNetwork
              />
            </div>
            {errMsgPhone && (
              <small className="text-danger">
                <AlertCircle size={15} />
                {errMsgPhone}
              </small>
            )}
            {selectedContact &&
            !isFetchingAddressBook &&
            ownerData?.userId !== selectedContact?.relationUserId &&
            dataSeller ? (
              <>
                <CardText
                  tag="h6"
                  className="text-sm mt-2"
                  style={{ paddingTop: errMsgPhone && '10px' }}
                >
                  Informasi pemanen
                </CardText>

                <Card className="border-0 shadow-sm" style={{ maxHeight: 68 }}>
                  <CardBody>
                    <div className="flex-centered justify-content-between">
                      <div className="flex-centered gap-2">
                        <ProfilePic
                          imgSrc={
                            dataSeller?.partnership?.logo ??
                            dataSeller?.profileImg
                          }
                          altText={
                            dataSeller?.partnership?.name ??
                            dataSeller?.fullName
                          }
                          name={
                            dataSeller?.partnership?.name ??
                            dataSeller?.fullName
                          }
                          avatarSeed={dataSeller?.userId}
                          width={36}
                          height={35}
                        />
                        <span className="text-sm fw-semibold">
                          {dataSeller?.partnership?.name ??
                            dataSeller?.fullName}
                        </span>
                      </div>
                      <Badge
                        size="sm"
                        disabled
                        className={
                          dataSeller?.profileStatus === 'VERIFIED'
                            ? 'badge-verify'
                            : 'badge-warning'
                        }
                      >
                        {dataSeller?.profileStatus === 'VERIFIED'
                          ? 'Terverifikasi'
                          : 'Belum Terverifikasi'}
                      </Badge>
                    </div>
                  </CardBody>
                </Card>
              </>
            ) : (
              <></>
            )}
            <div className="mt-4">
              {/* <CardText className="no-padding">
                Lokasi Panen (opsional)
              </CardText> */}
              <div style={{ width: '100%' }}>
                {/* <PMBSelect
                  placeholder="Pilih lokasi panen"
                  className="mt-2"
                  options={landplots}
                  onChange={(text) =>
                    onChangeDataStock('landplottingId', text?.value)
                  }
                /> */}
                <LandplotInputSelection
                  onSelectLandplot={(text) =>
                    onChangeDataStock('landplottingId', text?.value)
                  }
                  title="Lokasi Panen (opsional)"
                />
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        {(
          isPanen
            ? ownerData?.userId !==
              (selectedContact?.relationUserId ?? dataSeller?.userId)
            : warehousesAdd?.newData?.length > 0
        ) ? (
          <div className="mt-4">
            <CardText className="no-padding">
              Catatan hasil panen (opsional)
            </CardText>
            <div className="d-flex align-items-center">
              <div className="bordered mt-2" style={{ width: '100%' }}>
                <Input
                  style={{ borderColor: 'white', height: 200 }}
                  className="border-input"
                  type="textarea"
                  placeholder="Masukkan catatan jika ada..."
                  onChange={(text) =>
                    onChangeDataStock('note', text.target.value)
                  }
                  value={dataStock?.note}
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <div className="d-flex gap-3 mt-4">
          <Button
            onClick={() => {
              onClose()
              setDefaultWarehouseAddInventory(null)
            }}
            outline
            className="btn-cancel"
            block
          >
            Batal
          </Button>
          <Button
            disabled={isButtonDisabled || loading}
            onClick={() => onCreateStock('create', selectedProject)}
            color="primary"
            outline
            block
            data-testid="inventory-add-stock-submit-button"
          >
            Simpan
          </Button>
          <Button
            disabled={isButtonDisabled || loading}
            onClick={() => onCreateStock('repeat', selectedProject)}
            color="primary"
            block
          >
            Simpan dan Tambah
          </Button>
        </div>
      </div>
    </>
  )
}
